import React, { useEffect } from 'react'

export default function BtnSubmit({name,onListenner}) {
  
  return (
    <button className='s-btn' onClick={onListenner}>{name}</button>
  )
}
